import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Button,
  useColorModeValue,
} from '@chakra-ui/react';

import AutomacaoForm from './AutomacaoForm';

type AutomacaoModalProps = {
  isOpen: boolean;
  onClose: () => void;
  data?: {
    nome?: string;
    descricao?: string;
    gatilho?: string;
    configGatilho?: unknown;
  } | null;
};

export default function AutomacaoModal({
  isOpen,
  onClose,
  data,
}: AutomacaoModalProps) {
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />

      <ModalContent borderRadius="2xl">
        <ModalHeader
          color="gray.500"
          borderBottom="1px solid"
          borderColor={borderColor}
        >
          Nova Automação {data?.nome}
        </ModalHeader>

        <ModalCloseButton />

        <ModalBody>
          <AutomacaoForm data={data} />
        </ModalBody>

        <ModalFooter gap="3">
          <Button onClick={onClose} variant="ghost">
            Cancelar
          </Button>

          <Button colorScheme="blue">Conectar</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
